import React from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { isEmpty } from "../../lib/helpers/helpers";
import EmptyData from "../EmptyData/EmptyData";
import Masonry from "react-masonry-css";

import { DetailsHomeWrapper } from "./component";
import { Image, Skeleton } from "antd";
import { useViewSingleWeddingPhoto } from "../../redux/api/WeddingAPI";
import { v4 } from "uuid";

const DetailsPhoto = ({ details }) => {
	const data = {
		weddingId: details?.id,
		albumId: "",
		eventCode: details?.event_code,
	};
	const { data: albumData, isloading } = useViewSingleWeddingPhoto({
		...data,
	});

	console.log(albumData, details);

	const breakpointColumnsObj = {
		default: 3,
		700: 2,
	};
	return (
		<DetailsHomeWrapper tw="p-4">
			{isloading ? (
				<div tw="flex flex-row flex-wrap gap-4 justify-around">
					{Array.apply(null, Array(8)).map(() => {
						return (
							<Skeleton.Avatar
								active
								size="large"
								shape="square"
								key={v4()}
								width={160}
								height={160}
								tw="rounded-md"
							/>
						);
					})}
				</div>
			) : isEmpty(albumData?.data?.wedding_media) ? (
				<EmptyData description="No photos uploaded yet" />
			) : true || !details?.is_wedding_pictures_public ? (
				<EmptyData
					description={
						<span tw='font-semibold text-appPinkSaturated'>
							Restricted view...
							<br />
							Photo album is not available publicly
						</span>
					}
				/>
			) : (
				<Masonry
					breakpointCols={breakpointColumnsObj}
					className="my-masonry-grid"
					columnClassName="my-masonry-grid_column">
					{albumData?.data?.wedding_media?.map((img, i) => {
						console.log(img);
						return (
							<Image
								src={img.media_url}
								alt={"image"}
								width={"100%"}
								height={160}
								tw="rounded-md"
								placeholder={
									<Image
										src={img.media_url_min}
										preview={false}
									/>
								}
							/>
						);
					})}
				</Masonry>
			)}
		</DetailsHomeWrapper>
	);
};

export default DetailsPhoto;
